import { apiConstants, post } from './constants'

const SERVER_PREFIX = 'Exception:updatePricingDataBasedOnMerchant:donotuse:'

function failure(message, variant = 'error') {
    const error = new Error(message)
    error.variant = variant
    return error
}

/**
 * "Recalculate order value" for one order, in a single API call: forward, plus RTO when the order has
 * gone RTO (the server decides, using the same rule it enforces for RTO repricing) - instead of a
 * forward call followed by an RTO call that forward orders always had rejected.
 *
 * Resolves once repriced. Rejects with an Error whose message is meant for the user and whose
 * `variant` is the snackbar variant to show it with.
 */
export async function recalculatePricing({ orderId, merchantId, includeRTO = true }) {
    try {
        await post(apiConstants.RECALCULATE_PRICE, { orderId, merchantId, isRTO: false, includeRTO })
    } catch (err) {
        if (err?.response?.status === 429) {
            throw failure('Too many recalculations right now. Please retry in a few seconds.', 'warning')
        }
        const message = err?.response?.data?.message
        throw failure(message ? message.replace(SERVER_PREFIX, '').trim() : 'Something went wrong')
    }
}
